import { Subject } from './subject.model';
import {BaseFilterModel} from "./baseFilter.model";

export class DossierFilter  extends BaseFilterModel {
  public userId = null; // Id отвественного сотрудника
  public identificationType = null; // Вид идентификации клиента
  public result = false; // все/требующие решения
  public subject = new Subject();
}
